import React from 'react';
import { ShieldCheck, Atom, Dna, Cpu } from 'lucide-react';
import banner from '../../assets/images/banner.png';
import "./Aboutus.css";

const Aboutus = () => {
    return (
        <section id="about" className="cb-about-section">
            <div className="cb-about-glow"></div>
            <div className="container">
                <div className="cb-section-title-wrap">
                    <div className="cb-studio-tag">[ 01 // FOUNDATION ]</div>
                    <h2 className="cb-section-title">
                        About community
                    </h2>
                </div>

                <div className="cb-about-master-card">
                    <div className="cb-about-master-glow" aria-hidden="true"></div>
                    <div className="cb-about-grid">
                        <div className="cb-about-content-side">
                            <div className="cb-about-badge-header">
                                <div className="cb-about-icon-badge">
                                    <ShieldCheck size={28} strokeWidth={2.2} />
                                </div>
                                <div className="cb-about-badge-meta">
                                    <span className="cb-about-badge-tag">OPEN RESEARCH INITIATIVE</span>
                                    <h3 className="cb-about-badge-title">Empowering Collaborative Science</h3>
                                </div>
                            </div>

                            <p className="cb-about-text">
                                At ChemBioAI, we're dedicated to revolutionizing the fields of Artificial Intelligence (AI) and Life sciences. 
                                Our community brings together experts, researchers, and enthusiasts passionate about leveraging cutting-edge technology 
                                in the related field. We strive to facilitate open research projects, providing a platform for discussion, connection, 
                                and development. Our commitment is to foster a collaborative environment where members share skills and resources, 
                                advancing open research practices for collective growth and innovation.
                            </p>

                            <div className="cb-about-pillars-row">
                                <span className="cb-about-pill">
                                    <Atom size={15} strokeWidth={2.2} />
                                    <span>Chemistry</span>
                                </span>

                                <span className="cb-about-pill">
                                    <Dna size={15} strokeWidth={2.2} />
                                    <span>Biology</span>
                                </span>

                                <span className="cb-about-pill">
                                    <Cpu size={15} strokeWidth={2.2} />
                                    <span>Artificial Intelligence</span>
                                </span>
                            </div>
                        </div>

                        <div className="cb-about-image-side">
                            <div className="cb-about-img-frame">
                                <img 
                                    src={banner} 
                                    alt="ChemBioAI Community Members" 
                                    className="cb-about-banner-img" 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Aboutus;